import React, {useState,useEffect, useCallback} from 'react';
import styled, {keyframes} from 'styled-components'

const AnimateDots = keyframes`
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

const Dots = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

  span {
    width: 100vw;

    width: 6px;
    height: 6px;
    background: ${p=>p.background};
    display: inline-block;
    margin: 3px;
    border-radius: 50%;
    animation: ${AnimateDots} 2000ms linear infinite backwards;
    &:first-child {
      animation-delay: .1s;
    }
    &:nth-child(2) {
      animation-delay: .3s;
    }
    &:last-child {
      animation-delay: .5s;
    }
  }
`

const useDelayedRender = delay => {
  const [delayed, setDelayed] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => setDelayed(false), delay);
    return () => clearTimeout(timeout);
  }, []);
  return fn => !delayed && fn();
};

const DotLoader = ({background = 'rgba(0,0,0,0.6)'}) => {

    const delayedRender = useDelayedRender(1000);


    return delayedRender( () => (
        <Dots background={background}>
        <span/>
        <span/>
        <span/>
      </Dots>
    ))
}

export default DotLoader;